<!-- <pre>{{pipelineassetlink2s | json}}</pre> -->
<div class="main_form">
<mat-accordion>
    
  <mat-expansion-panel  hideToggle #example2 [expanded]="isExpanded" class="mat-elevation-z10" >
    <mat-expansion-panel-header class="mat-expan">
    <mat-panel-title>
    <h3 class="header"> Basic Information </h3>
    </mat-panel-title>
    
    <em class="ti-arrow-circle-down" style="font-size: 2.5rem;" *ngIf="!example2.expanded"></em> 
    <em class="ti-arrow-circle-right" style="font-size: 2.5rem;" *ngIf="example2.expanded"></em> 
    
    
  </mat-expansion-panel-header>
    <form class="contain" [formGroup]="pipelineForm">
    <div class="main_form">
        <div class="forms auto_style">
          
            <div class="auto">
              <div class="the_input">
                <label for="">Pipeline Code <em *ngIf="errorHandling('PipelineCode', 'required')">
                  <strong class="alert alert-danger" >*</strong></em> 
                </label>
                <input type="text" class="default_input" formControlName="PipelineCode"/>
              </div>

              <div class="auto_generate">
                <input type="radio" name="" id="" (click)="onChangeLandCodeGenerator()">Auto Generate
              </div>
            </div>

            <div class="the_input">
              <label for="">Pipeline Name<em *ngIf="errorHandling('PipelineName', 'required')">
                <strong class="alert alert-danger" >*</strong></em> 
              </label>
              <input type="text" class="default_input" formControlName="PipelineName"/>
            </div>

            <div class="the_input">
              <label for="">Installation Year<em *ngIf="errorHandling('InstallationYear', 'required')">
                <strong class="alert alert-danger" >*</strong></em> 
              </label>
              <select name="" id="" class="default_input" formControlName="InstallationYear">
                <option class='option' *ngFor="let year of years" [value]="year">
                  {{ year }}
                </option>
              </select>
              <!-- <input type="number" min="1900" max="2099" step="1" value="2016" class="default_input" formControlName="InstallationYear"/> -->
            </div>

            <div class="the_input">
              <label for="">License Status</label>
              <select name="" id="" class="default_input" formControlName="LicenceStatusId">
                <option class='option' *ngFor="let licence of licencestatuss" [value]="licence.id">
                  {{ licence.LicenceStatusName }}
                </option>
              </select>
            </div>

            <div class="the_input">
              <label for="">Licensed Expiration Date<em *ngIf="errorHandling('LicenceExpirationDate', 'required')">
                <strong class="alert alert-danger" >*</strong></em> 
              </label>
              <input type="date" class="default_input" formControlName="LicenceExpirationDate"/>
            </div>

            <div class="the_input">
              <label for="">OPLL No
              </label>
              <input type="text" class="default_input" formControlName="OPLLNumber"/>
            </div>

            <div class="the_input">
              <label for="">PTS No
              </label>
              <input type="text" class="default_input" formControlName="PTSNumber"/>
            </div>

            <div class="first_line">
              <button class="default_primary-button" *ngIf="!selectedPipelineDetails" (click)="onSubmit(pipelineForm.value)">Save</button>
              <button class="default_primary-button" *ngIf="selectedPipelineDetails" (click)="onSubmit(pipelineForm.value)">Update</button>
            </div>
            <div>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">S/N</th>
                    <th scope="col">Type</th>
                    <th scope="col">OPLL/PTS</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody style="height: 100px !important; overflow: scroll; ">
                  <tr  *ngFor="let opllpts of opllptshistorys index as i"
                  >
                    <td scope="row">{{i + 1}}</td>
                    <td>{{opllpts.Type}}</td>
                    <td>{{opllpts.OpllPtsNumber}}</td>
                    <td>{{opllpts.EntryDate | date}}</td>
                  </tr>
          
                </tbody>
              </table>
            </div>
            
        </div>
    </div> 
   </form>
  </mat-expansion-panel>

</mat-accordion>
</div>
<div class="other_contents">
<mat-tab-group class="ta" [disableRipple]=true [(selectedIndex)]="selectedTabIndex" #tabGroup (selectedTabChange)="tabChanged($event)"  *ngIf="showTab">
  <mat-tab>
    <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon">location_on</mat-icon>
        Pipeline Sections
    </ng-template>
  
    <cradua-pipelinesection
      [selectedPipelineDetails]="selectedPipelineDetails"
      [pipelinesections]="pipelinesections"
      [assetstatuss]="assetstatuss"
      [pigibilitys]="pigibilitys"
      [assetlocations]="assetlocations"
      [deliverytypes]="deliverytypes"
      [licencestatuss]="licencestatuss"
      [uomes]="uomes"
      [networks]="networks"
      [ipstatuss]="ipstatuss"
      [pipelinegrades]="pipelinegrades"
      [isLoadingPipelinesections]="isLoadingPipelinesections"
      (deleteEvent)="onEmitSectionDelete($event)"
      (emitSave)="onEmitSektionSubmit($event)"
      ></cradua-pipelinesection>
  
    </mat-tab>
  <mat-tab>
  <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">landscape</mat-icon>
      Link to Assets
  </ng-template>

  <cradua-pipelineassetlink
  [selectedPipelineDetails]="selectedPipelineDetails"
  [pipelineassetlink2s]="pipelineassetlink2s"
  [pipelineassets]="landTitles"
  [subsubgroups]="subsubgroups"
  [categorys]="categorys"
  [isLoadingPipelineassetlink2s]="isLoadingPipelineassetlink2s"
  (deleteEvent)="onEmitAssetDelete($event)"
  (emitSave)="onEmitAssetSubmit($event)"
  ></cradua-pipelineassetlink>

  </mat-tab>
  <mat-tab>
      <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">map</mat-icon>
      Accountable Function
      </ng-template>

  <cradua-accountablefunction
  [selectedPipelineDetails]="selectedPipelineDetails"
  [acountablefunctionlink2s]="acountablefunctionlink2s"
  [functions]="functions"
  [accountablefunctions]="accountablefunctions"
  [isLoadingAcountablefunctionlink2s]="isLoadingAcountablefunctionlink2s"
  (deleteEvent)="onEmitFxnDelete($event)"
  (emitSave)="onEmitFxnSubmit($event)"
  
  ></cradua-accountablefunction>

  </mat-tab>
  
</mat-tab-group>
</div>
